"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  FaceIdScan1: ['face-id-scan-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.993,17.261V14.984l.764.128a2.276,2.276,0,0,0,2.65-2.246V11l.71-.177a1.139,1.139,0,0,0,.671-1.736l-1.381-2.07V6.449c0-3.358-3.4-6.038-7.449-5.664A6.824,6.824,0,0,0,4.164,13.494v3.767', 'M20.266,22.324a1.5,1.5,0,0,1-2.772-1.148l2.87-6.929A1.5,1.5,0,1,1,23.136,15.4Z', 'M11.938,22.013a.125.125,0,1,1-.147-.1.124.124,0,0,1,.147.1', 'M9,22.6a.125.125,0,1,1-.147-.1A.124.124,0,0,1,9,22.6', 'M14.88,21.425a.125.125,0,0,1-.1.147.125.125,0,1,1-.049-.245.126.126,0,0,1,.147.1', 'M19.27,7.72a.125.125,0,1,1-.079.158.125.125,0,0,1,.079-.158', 'M20.211,10.568a.125.125,0,1,1-.08.158.126.126,0,0,1,.08-.158', 'M18.329,4.871a.125.125,0,1,1-.079.158.125.125,0,0,1,.079-.158']],
  FaceId6: ['face-id-6', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,18.75v3a1.5,1.5,0,0,1-1.5,1.5h-3', 'M18.75.75h3a1.5,1.5,0,0,1,1.5,1.5v3', 'M.75,5.25v-3A1.5,1.5,0,0,1,2.25.75h3', 'M5.25,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-3', 'M5.291,19.5a6.751,6.751,0,0,1,13.418,0', 'M7.876,7.986v1a5.91,5.91,0,0,1-.859,3.273', 'M16.124,7.986v1a5.91,5.91,0,0,0,.859,3.273', 'M7.888,8.205A5.484,5.484,0,0,0,12,6.305a5.484,5.484,0,0,0,4.112,1.9', 'M7.875 7.875 A4.125 4.125 0 1 0 16.125 7.875 A4.125 4.125 0 1 0 7.875 7.875 Z']],
  FaceId1: ['face-id-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M7.5,17.007a6.68,6.68,0,0,0,9,0', 'M6.75 6.75L6.75 9', 'M17.25 6.75L17.25 9', 'M12,6.75V12a1.5,1.5,0,0,1-1.5,1.5H9.75']],
  FaceId: ['face-id', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5,16.881a6.68,6.68,0,0,0,9,0', 'M6.75 6.624L6.75 8.874', 'M17.25 6.624L17.25 8.874', 'M12,6.624v5.25a1.5,1.5,0,0,1-1.5,1.5H9.75', 'M23.25,18.624v3a1.5,1.5,0,0,1-1.5,1.5h-3', 'M18.75.624h3a1.5,1.5,0,0,1,1.5,1.5v3', 'M.75,5.124v-3a1.5,1.5,0,0,1,1.5-1.5h3', 'M5.25,23.124h-3a1.5,1.5,0,0,1-1.5-1.5v-3']],
  FaceId7: ['face-id-7', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,18.75v3a1.5,1.5,0,0,1-1.5,1.5h-3', 'M18.75.75h3a1.5,1.5,0,0,1,1.5,1.5v3', 'M.75,5.25v-3A1.5,1.5,0,0,1,2.25.75h3', 'M5.25,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-3', 'M14.9,20.25V16.876l.7.118a2.1,2.1,0,0,0,2.444-2.071V13.2l.654-.164a1.049,1.049,0,0,0,.619-1.6L18.05,9.53V9.005c0-3.1-3.134-5.567-6.869-5.223A6.293,6.293,0,0,0,8.6,15.5V20.25']],
  FaceId8: ['face-id-8', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,15.338a4.454,4.454,0,0,0,6,0', 'M8.25 8.25L8.25 9.75', 'M15.75 8.25L15.75 9.75', 'M12,8.25v3a1.5,1.5,0,0,1-1.5,1.5H9.75', 'M12 0.75L12 1.5', 'M20.27 3.73L19.425 4.575', 'M23.25 12L22.5 12', 'M19.955 19.955L19.425 19.425', 'M12 23.25L12 22.5', 'M4.045 19.955L4.575 19.425', 'M0.75 12L1.5 12', 'M4.045 4.045L4.575 4.575', 'M3.750 12.000 A8.250 8.250 0 1 0 20.250 12.000 A8.250 8.250 0 1 0 3.750 12.000 Z']],
  FaceIdSmartphone: ['face-id-smartphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.250 0.750 L18.750 0.750 L18.750 23.250 L5.250 23.250 Z', 'M9,.75V3a.75.75,0,0,0,.75.75h4.5A.75.75,0,0,0,15,3V.75', 'M9,17.588a4.454,4.454,0,0,0,6,0', 'M8.25 9.75L8.25 12', 'M15.75 9.75L15.75 12', 'M12,9.75V13.5A1.5,1.5,0,0,1,10.5,15H9.75']],
  FaceIdApproved: ['face-id-approved', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.5,9h1.917a1.833,1.833,0,0,1,1.833,1.833V21.417a1.833,1.833,0,0,1-1.833,1.833H16.833A1.833,1.833,0,0,1,15,21.417V18', 'M10.993,17.261V14.984l.764.128a2.276,2.276,0,0,0,2.65-2.246V11l.71-.177a1.139,1.139,0,0,0,.671-1.736l-1.381-2.07V6.449c0-3.358-3.4-6.038-7.449-5.664A6.824,6.824,0,0,0,4.164,13.494v3.767', 'M21 15.375L18.375 18 17.25 16.5']],
  FaceId4: ['face-id-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,18.75v3a1.5,1.5,0,0,1-1.5,1.5h-3', 'M18.75.75h3a1.5,1.5,0,0,1,1.5,1.5v3', 'M.75,5.25v-3A1.5,1.5,0,0,1,2.25.75h3', 'M5.25,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-3', 'M7.875 9.000 A4.125 4.125 0 1 0 16.125 9.000 A4.125 4.125 0 1 0 7.875 9.000 Z', 'M18.365,19.125a6.751,6.751,0,0,0-12.73,0']],
  FaceId5: ['face-id-5', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,18.75v3a1.5,1.5,0,0,1-1.5,1.5h-3', 'M18.75.75h3a1.5,1.5,0,0,1,1.5,1.5v3', 'M.75,5.25v-3A1.5,1.5,0,0,1,2.25.75h3', 'M5.25,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-3', 'M8.445,6.531a6.858,6.858,0,0,0,7.643,1.536', 'M7.875 8.625 A4.125 4.125 0 1 0 16.125 8.625 A4.125 4.125 0 1 0 7.875 8.625 Z', 'M18.75,19.5a6.964,6.964,0,0,0-13.5,0']],
  FaceIdScan: ['face-id-scan', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M.865,13.607a18,18,0,0,1,22.271,0', 'M12 0.75L12 23.25', 'M18.606,21.107a6.752,6.752,0,0,0-13.212,0', 'M14.917,13.042a4.126,4.126,0,0,1-5.834,0', 'M7.876,10.225a4.125,4.125,0,1,1,8.248,0']],
  FaceId3: ['face-id-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,18.75v3a1.5,1.5,0,0,1-1.5,1.5h-3', 'M18.75.75h3a1.5,1.5,0,0,1,1.5,1.5v3', 'M.75,5.25v-3A1.5,1.5,0,0,1,2.25.75h3', 'M5.25,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-3', 'M9,20.25H7.081a3,3,0,0,1-3-3l.008-7.083A7.911,7.911,0,0,1,12,2.25h0a7.911,7.911,0,0,1,7.911,7.912l.008,7.083a3,3,0,0,1-3,3H15', 'M11.987,17.527A4.628,4.628,0,0,0,16.615,12.9V10.384C13.221,9.746,12,6.277,12,6.277s-1.245,3.469-4.643,4.107V12.9a4.628,4.628,0,0,0,4.628,4.629Z', 'M11.25 14.527L12.75 14.527']],
  FaceId9: ['face-id-9', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.625 10.875 A3.375 3.375 0 1 0 15.375 10.875 A3.375 3.375 0 1 0 8.625 10.875 Z', 'M17.08,18.5a6.066,6.066,0,0,0-10.16,0', 'M12 0.75L12 1.5', 'M20.242 3.758L19.425 4.575', 'M23.25 12L22.5 12', 'M19.955 19.955L19.425 19.425', 'M12 23.25L12 22.5', 'M4.045 19.955L4.575 19.425', 'M0.75 12L1.5 12', 'M4.045 4.045L4.575 4.575', 'M3.750 12.000 A8.250 8.250 0 1 0 20.250 12.000 A8.250 8.250 0 1 0 3.750 12.000 Z']],
  FaceId2: ['face-id-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,18.75v3a1.5,1.5,0,0,1-1.5,1.5h-3', 'M18.75.75h3a1.5,1.5,0,0,1,1.5,1.5v3', 'M.75,5.25v-3A1.5,1.5,0,0,1,2.25.75h3', 'M5.25,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-3', 'M6.75,12.75v.75a5.25,5.25,0,0,0,10.5,0v-.75', 'M12.749,5.3a5.25,5.25,0,0,0-6,5.2v2.25A6,6,0,0,0,12,9.656a6,6,0,0,0,5.25,3.094V10.5A5.251,5.251,0,0,0,12.749,5.3Z', 'M11.25 15.75L12.75 15.75']]
};
exports["default"] = _default;